<template>
  <auth-layout pageClass="login-page">
    <div class="row d-flex justify-content-center align-items-center">
      <div class="col-lg-12 col-md-12 col-sm-12">
        <div class="row" v-if="loadingRegistration" v-loading="loadingRegistration" id="loading">
        </div>
        <div v-if="successMessage" class="card text-center">
          <h3 class="card-title text-primary">
            <i class="nc-icon nc-check-2"></i>{{successMessage}}
          </h3>
          <router-link to="/login" class="btn btn-primary btbtn-wd" href="/notices">
            <i class="nc-icon nc-stre-right"></i> Ir para Área do Aluno
          </router-link>
        </div>
        <form v-if="!loadingRegistration&&!successMessage" @submit.prevent="register" method="post">
          <!--You can specify transitions on initial render. The `card-hidden` class will be present initially and then it will be removed-->
          <fade-render-transition>
            <card>
              <div class="header">
                <h4 class="card-title"><i class="nc-icon nc-notes"></i> Preencha o Formulário de Inscrição:</h4>
              </div>
              <hr/>
              <div class="row">
                <div class="col-md-3">
                  <fg-input type="email"
                            required
                            label="E-mail:"
                            placeholder="email@email.com"
                            v-model="studentProfile.email">
                  </fg-input>
                </div>
                <div class="col-md-3">
                  <fg-input type="text"
                            required
                            label="Nome:"
                            placeholder="Primeiro Nome"
                            v-model="studentProfile.name">
                  </fg-input>
                </div>
                <div class="col-md-3">
                  <fg-input type="text"
                            required
                            label="Sobrenome:"
                            placeholder="Sobrenome"
                            v-model="studentProfile.surname">
                  </fg-input>
                </div>
                <div class="col-md-3">
                  <fg-input type="text"
                            required
                            label="CPF:"
                            placeholder="Somente Números"
                            v-mask="'###.###.###-##'"

                            v-model="studentProfile.cpf">
                  </fg-input>
                </div>
              </div>
              <div class="row">
                <div class="col-md-3">
                  <fg-input type="tel"
                            required
                            label="Data de Nascimento:"
                            placeholder="##/##/####"
                            v-mask="'##/##/####'"
                            maxlength="10"
                            v-model="studentProfile.birthdate">
                  </fg-input>
                </div>
                <div class="col-md-3">
                  <label>Sexo:</label>
                  </br>
                  <el-select class="select-primary col-md-12"
                             required
                             size="large"
                             placeholder="Selecione Aqui..."
                             v-model="studentProfile.gender">
                    <el-option v-for="option in selects.genders"
                               class="select-danger"
                               :value="option.value"
                               :label="option.label"
                               :key="option.label">
                    </el-option>
                  </el-select>
                </div>
                <div class="col-md-3">
                  <label>Profissão:</label>
                  </br>
                  <el-select class="select-primary col-md-12"
                             required
                             size="large"
                             placeholder="Selecione Aqui..."
                             v-model="studentProfile.job">
                    <el-option v-for="option in jobs"
                               class="select-danger"
                               :value="option"
                               :label="option"
                               :key="option">
                    </el-option>
                  </el-select>
                </div>
                <div class="col-md-3">
                  <fg-input type="text"
                            required
                            label="CEP:"
                            placeholder="CEP - Somente Números"
                            maxlength="8"
                            v-model="studentProfile.cep">
                  </fg-input>
                </div>
              </div>

              <div class="row">
                <div class="col-md-3">
                  <fg-input type="text"
                            required
                            label="Endereço:"
                            placeholder="Av. Endereço."
                            v-model="studentProfile.address">
                  </fg-input>
                </div>
                <div class="col-md-3">
                  <fg-input type="text"
                            required
                            label="Número:"
                            placeholder="####"
                            v-model="studentProfile.address_number">
                  </fg-input>
                </div>
                <div class="col-md-3">
                  <fg-input type="text"
                            required
                            label="Complemento:"
                            placeholder="Complemento."
                            v-model="studentProfile.address_complement">
                  </fg-input>
                </div>
                <div class="col-md-3">
                  <label>País: *</label>
                  </br>
                  <el-select class="select-primary col-md-12"
                             required
                             size="large"
                             placeholder="Selecione Aqui..."
                             v-model="studentProfile.country">
                    <el-option v-for="(option) in countries"
                               class="select-danger"
                               :value="option.nome"
                               :label="option.nome"
                               :key="option.ordem">
                    </el-option>
                  </el-select>
                </div>
              </div>

              <div class="row">
                <div class="col-md-3">
                  <label>Estado: *</label>
                  </br>
                  <el-select class="select-primary col-md-12"
                             required
                             size="large"
                             placeholder="Selecione Aqui..."
                             v-model="studentProfile.state"
                             @change="setStateIndex()">
                    <el-option v-for="(option, index) in states"
                               class="select-danger"
                               :value="option.nome"
                               :label="option.nome"
                               :key="option.sigla">
                    </el-option>
                  </el-select>
                </div>
                <div class="col-md-3">
                  <label>Cidade: *</label>
                  </br>
                  <el-select class="select-primary col-md-12"
                             required
                             size="large"
                             placeholder="Selecione Aqui..."
                             v-model="studentProfile.city">
                    <el-option v-for="(option) in states[stateIndex].cidades"
                               class="select-danger"
                               :value="option"
                               :label="option"
                               :key="option">
                    </el-option>
                  </el-select>
                </div>
                <div class="col-md-3">
                  <fg-input type="text"
                            required
                            label="Telefone-Celular (Whatsapp):"
                            placeholder="Somente Números"
                            maxlength="11"
                            v-model="studentProfile.cellphone">
                  </fg-input>
                </div>
                <div class="col-md-3">
                  <fg-input type="text"
                            required
                            label="Link Facebook:"
                            placeholder="Digite aqui."
                            v-model="studentProfile.facebook_link">
                  </fg-input>
                </div>
              </div>

              <div class="row">
                <div class="col-md-6">
                  <fg-input type="password"
                            required
                            label="Senha:"
                            placeholder="Deve conter no mínimo 6 dígitos"
                            v-model="studentProfile.password">
                  </fg-input>
                </div>
                <div class="col-md-6">
                  <fg-input type="password"
                            required
                            label="Confirmar Senha:"
                            placeholder="Repita nova senha"
                            v-model="studentProfile.password_confirmation">
                  </fg-input>
                </div>
              </div>
              <hr/>
              <div class="text-center">
                <div class="text-danger">
                  <p class="text-left" v-if="formErrors.length">
                    <b>Por favor, corrija o(s) seguinte(s) erro(s):</b>
                  <ul>
                    <li v-for="error in formErrors">{{ error }}</li>
                  </ul>
                  </p>
                </div>
                <br />
                <h5>
                  <small class="text-danger pull-left">
                    *Campo Obrigatório. Todos os campos são obrigatórios.
                  </small>
                </h5>
                <br />
                <a href="http://res.cloudinary.com/toptrader/raw/upload/v1521742899/TERMOS_E_CONDI%C3%87%C3%95ES_DE_USO_TOP_TRADER_j97vhz.pdf" target="_blank">
                  Termos de Serviço
                </a>
                |
                <a href="https://acompanhamento.everinvestor.com.br/termos.pdf" target="_blank">
                  Contrato de Prestação de Serviço
                </a>
                <br />
                <div>
                  <input type="checkbox" id="optionContract" v-model="agreeWithToS">
                  <label for="optionContract">
                    Concordo com os Termos e Contrato de Prestação de Serviço
                  </label>
                </div>
                <br />
                <button class="btn btn-info btn-fill btn-wd"
                        type="submit">
                  <i class="nc-icon nc-send"></i> Enviar Inscrição
                </button>
              </div>
              <div class="clearfix"></div>
            </card>
          </fade-render-transition>
        </form>
      </div>
    </div>
  </auth-layout>
</template>
<script>
import Vue from 'vue'
import {Loading, Select, Option} from 'element-ui'
import {mask} from 'vue-the-mask'
import { Checkbox, FadeRenderTransition } from 'src/components/index'
import AuthLayout from './AuthLayout.vue'

// Utilities
import { BrazilianStates } from 'src//utils/modals/brazilian-states'
import { Countries } from 'src/utils/modals/countries'
import { Jobs } from 'src/utils/modals/jobs'

Vue.use(Loading.directive)

export default {
  components: {
    Checkbox,
    FadeRenderTransition,
    AuthLayout,
    [Select.name]: Select,
    [Option.name]: Option
  },
  directives: {mask},
  data () {
    return {
      agreeWithToS: false,
      formErrors: [],
      successMessage: '',
      loadingRegistration: false,
      studentProfile: {
        name: '',
        surname: '',
        email: '',
        gender: '',
        job: '',
        cpf: '',
        birthdate: '',
        cellphone: '',
        cep: '',
        address: '',
        address_complement: '',
        address_number: '',
        city: '',
        state: '',
        country: '',
        is_foreign_country: '',
        facebook_link: '',
        password: '',
        password_confirmation: ''
      },
      selects: {
        genders: [
          {value: 'M', label: 'Masculino'},
          {value: 'F', label: 'Feminino'},
          {value: 'N', label: 'Prefiro não Informar'}
        ],
        isForeignCountry: [
          {value: 1, label: 'Sim'},
          {value: 0, label: 'Não'}
        ]
      },
      jobs: Jobs,
      countries: Countries,
      states: BrazilianStates.estados,
      stateIndex: 0
    }
  },
  methods: {
    notifyVue (message, verticalAlign, horizontalAlign, color, icon) {
      this.$notify(
        {
          component: {
            template: `<h5 class="card-title">${message}</h5>`
          },
          icon: 'nc-icon ' + icon,
          horizontalAlign: horizontalAlign,
          verticalAlign: verticalAlign,
          type: color
        })
    },
    register () {
      this.loadingRegistration = true
      this.formErrors = []

      if (!this.agreeWithToS) {
        this.loadingRegistration = false
        this.formErrors.push('É necessário concordar com os termos e contrato de prestação de serviço antes prosseguir.')
      } else if (
        !this.studentProfile.name && !this.studentProfile.surname &&
        !this.studentProfile.email && !this.studentProfile.gender &&
        !this.studentProfile.job && !this.studentProfile.cpf &&
        !this.studentProfile.birthdate && !this.studentProfile.cellphone &&
        !this.studentProfile.cep && !this.studentProfile.address &&
        !this.studentProfile.address_complement && !this.studentProfile.address_number &&
        !this.studentProfile.city && !this.studentProfile.state &&
        !this.studentProfile.country && !this.studentProfile.is_foreign_country &&
        !this.studentProfile.facebook_link
      ) {
        this.loadingRegistration = false
        this.formErrors.push('Todos os campos devem ser preenchidos obrigatoriamente.')
      } else {
        if (this.studentProfile.country == 'Brasil') {
          this.studentProfile.is_foreign_country = 0
        } else {
          this.studentProfile.is_foreign_country = 1
        }
        this.axios
          .post('/register_student', this.studentProfile)
          .then(response => {
            this.loadingRegistration = false
            if (response.data.type === 'error') {
              this.formErrors.push(response.data.message)
            } else {
              this.successMessage = response.data.message
            }
          })
          .catch(error => {
            this.loadingRegistration = false
            console.log(error)
            alert('Inscrição não realizada. Verifique se seu email e CPF são válidos.')
          })
      }
    },
    setStateIndex () {
      let index = 0
      this.studentProfile.city = ''
      for (let state of this.states) {
        if (state.nome === this.studentProfile.state) {
          this.stateIndex = index
        }
        index++
      }
    }
  }
}
</script>
<style>
.navbar-nav .nav-item p{
  line-height: inherit;
  margin-left: 5px;
}
</style>
<style>
#loading {
  min-height: 200px;
  display: flex;
  align-items: center;
.el-loading-spinner .path {
  stroke: #000 !important;
}
.el-loading-mask {
  background: transparent !important;
}
}

.el-dialog {
  width: 50%;
}
@media (max-width: 800px){
  .el-dialog{
    width: 90%
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/Dashboard/Pages/Register.vue